import api from '../config/api';

export const recruitmentCompanyVacancyService = {
  /**
   * Get all vacancies for recruitment company
   * @param {Object} filters
   * @returns {Promise}
   */
  getAll: async (filters = {}) => {
    const response = await api.get('/recruitment-company/vacancies', { params: filters });
    return response.data;
  },

  /**
   * Get vacancy by ID
   * @param {number} id
   * @returns {Promise}
   */
  getById: async (id) => {
    const response = await api.get(`/recruitment-company/vacancies/${id}`);
    return response.data;
  },

  /**
   * Create a new vacancy
   * @param {Object} data
   * @returns {Promise}
   */
  create: async (data) => {
    const response = await api.post('/recruitment-company/vacancies', data);
    return response.data;
  },

  /**
   * Update a vacancy
   * @param {number} id
   * @param {Object} data
   * @returns {Promise}
   */
  update: async (id, data) => {
    const response = await api.put(`/recruitment-company/vacancies/${id}`, data);
    return response.data;
  },

  /**
   * Delete a vacancy
   * @param {number} id
   * @returns {Promise}
   */
  delete: async (id) => {
    const response = await api.delete(`/recruitment-company/vacancies/${id}`);
    return response.data;
  },

  /**
   * Get applications for a vacancy
   * @param {number} vacancyId
   * @returns {Promise}
   */
  getApplications: async (vacancyId) => {
    const response = await api.get(`/recruitment-company/vacancies/${vacancyId}/applications`);
    return response.data;
  },

  /**
   * Change application status
   * @param {number} vacancyId
   * @param {number} applicationId
   * @param {string} status - 'pending', 'viewed', 'accepted', 'rejected'
   * @returns {Promise}
   */
  changeApplicationStatus: async (vacancyId, applicationId, status) => {
    const response = await api.put(`/recruitment-company/vacancies/${vacancyId}/applications/${applicationId}/status`, { status });
    return response.data;
  },
};

